import { disableTransition } from "../include/module";
import { preLoad } from "../include/module";
import { anchorLink } from "../include/module";
import { animParticle } from "../include/module";
import { pickupSlider } from "../include/module";
import { toggleNav } from "../include/module";
import { toggleTotop } from "../include/module";
import { animScroll } from "../include/module";
import { animLoad } from "../include/module";
import { gachaSwitch } from "../include/module";
import { imageModal } from "../include/module";
import { movieModal } from "../include/module";





(() => {

  disableTransition();
  preLoad();
  anchorLink();
  animParticle();
  pickupSlider();
  toggleNav();
  toggleTotop();
  animScroll();
  animLoad();
  gachaSwitch();
  imageModal();
  movieModal();

})();



// WEBPACK FOOTER //
// ./src/assets/js/gallery/script.js